import { useQuery } from "@tanstack/react-query";
import { queryOptions_me } from "@/lib/providers/query/functions/user/me";
import { useSessionProvider } from "@/lib/providers/session/use-session";

export function useMe() {
  const sessionProvider = useSessionProvider();

  const user = sessionProvider.session.data?.user;

  const meQuery = useQuery({
    ...queryOptions_me({}),
    enabled: !!user,
  });

  const isLoading = sessionProvider.session.isPending || meQuery.isLoading;
  const isNotEmployee = meQuery.data?.employee === null && !isLoading;
  const isAdmin = meQuery.data?.adminUser !== null && !isLoading;

  return {
    me: meQuery.data,
    sessionProvider,
    meQuery,
    isLoading,
    isNotEmployee,
    isAdmin,
  };
}
